// S43: Reopen Requests API Endpoints
import { apiClient } from './client';

export interface ReopenRequest {
  id: string;
  status: 'pending_admin_review' | 'approved' | 'rejected';
  initiated_at: string;
  reviewed_at: string | null;
  required_contribution_cents: number | null;
  reason: string | null;
  user: {
    id: string;
    full_name: string;
    email: string;
    participation_status: string;
    exit_effective_at: string;
    retained_until: string | null;
    contributed_amount_cents: number;
    base_principal_cents: number;
    min_required_contribution_cents: number;
  };
  reviewed_by_admin: {
    id: string;
    full_name: string;
  } | null;
}

export interface ReopenRequestsResponse {
  reopen_requests: ReopenRequest[];
  page: number;
  per_page: number;
  total: number;
}

export interface ReopenStatusResponse {
  participation_status: string;
  can_request_reopen: boolean;
  reopen_request: {
    id: string;
    status: string;
    initiated_at: string;
    reviewed_at: string | null;
    required_contribution_cents: number | null;
    reason: string | null;
  } | null;
  funding_status?: {
    required_contribution_cents: number;
    contributed_amount_cents: number;
    remaining_cents: number;
    is_funded: boolean;
  };
}

// User-side endpoints
export const userReopenRequestsEndpoints = {
  async requestReopen(): Promise<{ message: string; status: string; reopen_request: any }> {
    return await apiClient.post('/api/me/reopen_requests/request');
  },

  async getStatus(): Promise<ReopenStatusResponse> {
    return await apiClient.get('/api/me/reopen_requests/status');
  },
};

// Admin endpoints
export const adminReopenRequestsEndpoints = {
  async getReopenRequests(params?: {
    status?: string;
    page?: number;
    per_page?: number;
  }): Promise<ReopenRequestsResponse> {
    return await apiClient.get('/api/admin/reopen_requests', { params });
  },

  async approveReopenRequest(
    id: string,
    required_contribution_cents: number
  ): Promise<{ message: string; reopen_request: ReopenRequest; user: any }> {
    return await apiClient.post(`/api/admin/reopen_requests/${id}/approve`, {
      required_contribution_cents,
    });
  },

  async rejectReopenRequest(
    id: string,
    reason?: string
  ): Promise<{ message: string; reopen_request: ReopenRequest }> {
    return await apiClient.post(`/api/admin/reopen_requests/${id}/reject`, {
      reason,
    });
  },
};
